export default __webpack_public_path__ + "static/media/about_banner_bg.2a07ddd8.jpg";